import {lightColors} from 'shared/assets/colors';

export const textSizes = {
  'extra-small': 10,
  small: 12,
  regular: 14,
  medium: 16,
  large: 18,
  'extra-large': 24,
  'extra-extra-large': 32,
};

export interface BaseTextProps {
  size?: keyof typeof textSizes;
  color?: keyof typeof lightColors;
  textAlign?: 'left' | 'center' | 'right';
  scaleText?: boolean;
}
